import HttpUtil from '@/common/HttpUtil'

const menuApi = {
  //获取当前用户的角色菜单
  getMenu () {
    let url = process.env.VUE_APP_DOMAIN + '/column';
    return HttpUtil.get(url)
  }
};
export default menuApi
